import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { RefundSEO } from '../components/SEO';

const Refund = () => {
  return (
    <div className="min-h-screen bg-white">
      <RefundSEO />
      <Header />
      
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-16">
        <h1 className="font-playfair text-4xl md:text-5xl font-bold mb-12 text-[#1a1a1a]">
          Refund Policy
        </h1>
        
        <div className="space-y-8 font-manrope text-sm">
          <section>
            <h2 className="font-playfair text-2xl font-bold mb-4 text-[#1a1a1a]">1. Editorial Rejection</h2>
            <p className="text-[#737373] mb-2">
              If content is rejected by the publication's editorial team:
            </p>
            <ul className="list-disc list-inside text-[#737373] space-y-1 ml-4">
              <li>Client may select a replacement outlet of equal or lesser value</li>
              <li>OR receive a full refund of the publication fee</li>
              <li>Decision must be made within 7 days of rejection notification</li>
            </ul>
          </section>
          
          <section>
            <h2 className="font-playfair text-2xl font-bold mb-4 text-[#1a1a1a]">2. Writing Service Fees</h2>
            <p className="text-[#737373]">
              Writing service fees are non-refundable once the draft has been delivered to the client. This applies regardless of publication outcome.
            </p>
          </section>
          
          <section>
            <h2 className="font-playfair text-2xl font-bold mb-4 text-[#1a1a1a]">3. Processing Time</h2>
            <p className="text-[#737373]">
              Approved refunds are processed within 7-10 business days to the original payment method.
            </p>
          </section>
          
          <section>
            <h2 className="font-playfair text-2xl font-bold mb-4 text-[#1a1a1a]">4. Non-Refundable Scenarios</h2>
            <ul className="list-disc list-inside text-[#737373] space-y-1 ml-4">
              <li>Content successfully published</li>
              <li>Client-provided content does not meet publication guidelines</li>
              <li>Client misses submission deadlines</li>
              <li>After article has been submitted to publisher (without rejection)</li>
            </ul>
          </section>
          
          <section>
            <h2 className="font-playfair text-2xl font-bold mb-4 text-[#1a1a1a]">5. Cancellation</h2>
            <p className="text-[#737373]">
              Orders can be cancelled for a full refund only before content submission. Once submitted to the editorial team, standard refund policies apply.
            </p>
          </section>
          
          <section>
            <h2 className="font-playfair text-2xl font-bold mb-4 text-[#1a1a1a]">Contact</h2>
            <p className="text-[#737373]">
              For refund requests or questions, contact support@businessmintpr.com with your order ID.
            </p>
          </section>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Refund;